export const SOLO_CHANNEL = 'Solo Channel';
// NOTE: If you are adding a shortcut here, ensure it's also added to the relevant category in ShortcutPresentation
export var Shortcut;
(function (Shortcut) {
    Shortcut["PlayPause"] = "Play/Pause";
    Shortcut["SeekForward5"] = "Seek Forward 5 seconds";
    Shortcut["SeekBackwards5"] = "Seek Backwards 5 seconds";
    Shortcut["IncreasePlaybackSpeed"] = "Increase Playback Speed";
    Shortcut["DecreasePlaybackSpeed"] = "Decrease Playback Speed";
    Shortcut["ToggleMute"] = "Toggle Mute";
    Shortcut["IncreaseVolume"] = "Increase Volume";
    Shortcut["DecreaseVolume"] = "Decrease Volume";
    Shortcut["SeekToEnd"] = "Seek To End";
    Shortcut["SelectPlaybackTime"] = "Select Playback Time";
    Shortcut["SelectPlayhead"] = "Select Playhead";
    Shortcut["TurnAllChannelsOn"] = "Turn All Channels On";
    Shortcut["ToggleChannelsPanel"] = "Toggle Channels Panel";
    // NOTE: These labels must be in the format `{SOLO_CHANNEL} {number}`
    Shortcut["SoloChannelOne"] = "Solo Channel 1";
    Shortcut["SoloChannelTwo"] = "Solo Channel 2";
    Shortcut["SoloChannelThree"] = "Solo Channel 3";
    Shortcut["SoloChannelFour"] = "Solo Channel 4";
    Shortcut["SoloChannelFive"] = "Solo Channel 5";
    Shortcut["SoloChannelSix"] = "Solo Channel 6";
    Shortcut["SoloChannelSeven"] = "Solo Channel 7";
    Shortcut["SoloChannelEight"] = "Solo Channel 8";
    Shortcut["SoloChannelNine"] = "Solo Channel 9";
    Shortcut["SoloChannelTen"] = "Solo Channel 10";
    Shortcut["SoloChannelEleven"] = "Solo Channel 11";
    Shortcut["SoloChannelTwelve"] = "Solo Channel 12";
    Shortcut["SoloChannelThirteen"] = "Solo Channel 13";
    Shortcut["SoloChannelFourteen"] = "Solo Channel 14";
    Shortcut["SoloChannelFifteen"] = "Solo Channel 15";
    Shortcut["SoloChannelSixteen"] = "Solo Channel 16";
})(Shortcut || (Shortcut = {}));
